/**
 * Amity CDN serves smaller variants by default; profile screens request `size=large`.
 */
export function toAmityLargeImageUrl(fileUrl: string | undefined | null): string | undefined {
  if (!fileUrl?.trim()) {
    return undefined;
  }
  const url = fileUrl.trim();
  if (/[?&]size=/i.test(url)) {
    return url.replace(/([?&])size=[^&]*/i, "$1size=large");
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}size=large`;
}
